/**
 * Schema estruturado para a seção de calculadora
 * Formato: Schema.org - SoftwareApplication
 */
export const calculatorSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  'name': 'Calculadora de Juros Compostos',
  'applicationCategory': 'FinanceApplication',
  'operatingSystem': 'Web',
  'offers': {
    '@type': 'Offer',
    'price': '0',
    'priceCurrency': 'BRL'
  },
  'description': 'Calcule o crescimento do seu dinheiro com nossa calculadora de juros compostos. Planeje seu futuro financeiro com precisão.',
  'featureList': 'Simulação de juros compostos, Visualização gráfica, Comparação de cenários, Marcos financeiros, Planejamento de aposentadoria',
  'screenshot': 'https://calculadora-juros-compostos.com/images/calculator-screenshot.jpg',
  'softwareVersion': '1.0.0',
  'aggregateRating': {
    '@type': 'AggregateRating',
    'ratingValue': '4.8',
    'ratingCount': '125'
  }
};
